import { api } from "@/services";

async function useChangeCartStep(
  chekoutId: string,
  step: string
): Promise<[string, string]> {
  let SResponse = null;
  let SError = null;

  const Controller = new AbortController();

  const MakeRequest = async () => {
    try {
      const Resp = await api.post(`/Cart/ChangeCartPhase`, null, {
        signal: Controller.signal,
        params: {
          CheckoutId: chekoutId,
          fase: step,
        },
      });

      if (Resp.status === 200 && Resp.data && Resp.data?.status === true) {
        SResponse = "OK";
      }
    } catch (serror) {
      SError = serror.message;
    }
  };

  await MakeRequest();

  Controller.abort();

  return [SResponse, SError];
}

export { useChangeCartStep };
